import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { BuildingDetailForm } from "@/features/building/BuildingDetailForm";
import { useParams } from "react-router-dom";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";

export function BuildingDetail() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/category-bizzpass",
            label: "Category BizzPass",
          },
          {
            label: "Detail",
          },
        ]}
      />
      <H2>Category BizzPass Detail</H2>
      <BuildingDetailForm id={id} />
    </>
  );
}
